import { render, staticRenderFns } from "./UpsertPromotion.vue?vue&type=template&id=9371c8cc&scoped=true"
import script from "./UpsertPromotion.vue?vue&type=script&lang=js"
export * from "./UpsertPromotion.vue?vue&type=script&lang=js"
import style0 from "./UpsertPromotion.vue?vue&type=style&index=0&id=9371c8cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9371c8cc",
  null
  
)

export default component.exports